import { Link, useNavigate } from "react-router-dom";
import { variantBAssets } from "../../../landers/Utils/variantBAssets";

const callHref = "tel:08082812558";

type LanderV2FunnelNavProps = {
  campaignRoute?: string;
  previousPath?: string;
  startOver?: boolean;
  onBack?: () => void;
  onStartOver?: () => void;
};

export function LanderV2FunnelNav({
  campaignRoute = "/",
  previousPath,
  startOver = false,
  onBack,
  onStartOver,
}: LanderV2FunnelNavProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(previousPath ?? campaignRoute);
  };

  const backIcon = <i className="bi bi-chevron-left" aria-hidden="true"></i>;
  const logo = <img src={variantBAssets.penseLogo} alt="Pense" />;

  return (
    <header className="lv2-funnel-nav">
      <nav className="lv2-funnel-nav-inner" aria-label="Quote navigation">
        {startOver ? (
          onStartOver ? (
            <button className="lv2-back-link" type="button" onClick={onStartOver}>
              {backIcon}
              Start over
            </button>
          ) : (
            <Link className="lv2-back-link" to={campaignRoute}>
              {backIcon}
              Start over
            </Link>
          )
        ) : (
          <button className="lv2-back-link" type="button" onClick={handleBack}>
            {backIcon}
            Back
          </button>
        )}
        {onStartOver ? (
          <button type="button" className="lv2-funnel-brand" aria-label="Pense" onClick={onStartOver}>
            {logo}
          </button>
        ) : (
          <Link to={campaignRoute} className="lv2-funnel-brand" aria-label="Pense">
            {logo}
          </Link>
        )}
        <a className="lv2-funnel-call" href={callHref}>
          Call us
          <i className="bi bi-telephone" aria-hidden="true"></i>
        </a>
      </nav>
    </header>
  );
}
